import { create } from "zustand";
import { message } from "antd";

import AdminApiCaller from "../config/api/adminapicaller";

const initialState = {
  blogs: [],
  blogsCount: 0,
  blog: {},
  isLoading: false,
  isBlogLoading: false,
  error: null,
};

export const useBlogStore = create((set) => {
  const setBlogs = (partial) => set((state) => ({ ...state, ...partial }));

  return {
    ...initialState,
    addBlog: async (payload, cb) => {
      try {
        setBlogs({ isLoading: true, error: null });
        const res = await AdminApiCaller.Post("/add-blog", payload);
        if (res?.status === 200) {
          message.success(res.data.message);
        } else {
          message.error(res.data.message);
        }
        setBlogs({ isLoading: false });
        if (cb) cb(res?.data);
      } catch (err) {
        setBlogs({ isLoading: false, error: err });
      }
    },
    getBlogs: async (payload, cb) => {
      try {
        setBlogs({ isLoading: true, error: null });
        const res = await AdminApiCaller.Get("/get-blogs", payload);
        if (res?.status === 200) {
          setBlogs({
            blogs: res.data.pages,
            blogsCount: res.data.count,
            isLoading: false,
          });
        } else {
          setBlogs({ isLoading: false });
        }
        if (cb) cb(res?.data);
      } catch (err) {
        setBlogs({ isLoading: false, error: err });
      }
    },
    getBlog: async (payload, cb) => {
      try {
        setBlogs({ isBlogLoading: true, error: null });
        const res = await AdminApiCaller.Get(`/get-blog?id=${payload?.id}`);
        if (res?.status === 200) {
          setBlogs({ blog: res.data.page, isBlogLoading: false });
        } else {
          setBlogs({ isBlogLoading: false });
        }
        if (cb) cb(res?.data);
      } catch (err) {
        setBlogs({ isBlogLoading: false, error: err });
      }
    },
    updateBlog: async (payload, cb) => {
      try {
        setBlogs({ isBlogLoading: true, error: null });
        const res = await AdminApiCaller.Put("/update-blog", payload);
        if (res?.status === 200) {
          message.success(res.data.message);
        } else {
          message.error(res.data.message);
        }
        setBlogs({ isBlogLoading: false });
        if (cb) cb(res?.data);
      } catch (err) {
        setBlogs({ isBlogLoading: false, error: err });
      }
    },
    deleteBlog: async (payload, cb) => {
      try {
        setBlogs({ isLoading: true, error: null });
        const res = await AdminApiCaller.Delete(`/delete-blog?id=${payload.id}`);
        if (res?.status === 200) {
          message.success(res.data.message);
        } else {
          message.error(res.data.message);
        }
        setBlogs({ isLoading: false });
        if (cb) cb(res?.data);
      } catch (err) {
        setBlogs({ isLoading: false, error: err });
      }
    },
    reset: () => set(initialState),
  };
});
